// extracted by mini-css-extract-plugin
module.exports = {"root":"investment_root__2JMHt","amlContainer":"investment_amlContainer__19rqi","icon":"investment_icon__ViFqy"};